import { createElement, memo, useEffect, useRef, forwardRef } from '@max/max';
import Player, { Events } from '@mtfe/oneplayer';
import SimplePreset from '@mtfe/oneplayer/es/presets/miniscreen';
import HlsPlugin from '@mtfe/oneplayer-hls';
import '@mtfe/oneplayer/dist/index.min.css';
import { remUnit } from '@max/leez-style-util';
import './index.scss';
import View from '@hfe/max-view';
import { isMiniProgramOrWebview } from '@nibfe/mkt-env-api';
import Image from '@max/leez-image';
import { PLAY_STATUS } from '../../constants/index';
const Video = forwardRef((props, ref) => {
    const { liveWindowWidth, liveWindowHeight, liveId, videoUrl, isPlaying, onVideoError, onVideoCompleted, handleVideoPlaying, posterUrl = 'https://p0.meituan.net/ingee/7624e3bb113d69665255ad3f01ae9ddd1055983.png@327w_184h' } = props;
    const player = useRef();
    function play() {
        var _a;
        if (!(player === null || player === void 0 ? void 0 : player.current)) {
            return;
        }
        (_a = player.current) === null || _a === void 0 ? void 0 : _a.play();
        handleVideoPlaying(PLAY_STATUS.LIVE_DOING);
    }
    const initPlayer = () => {
        if (player.current)
            return;
        player.current = new Player({
            id: "live-player",
            url: videoUrl,
            env: 'prod',
            service: 'tex_hotel_live_reserve',
            height: "100%",
            width: "100%",
            videoFillMode: 'fillWidth',
            fitVideoSize: 'fitWidth',
            isLive: true,
            plugins: [HlsPlugin],
            autoplay: false,
            autoplayMuted: true,
            enableTrafficControl: false,
            'x5-video-player-type': 'h5',
            presets: [SimplePreset],
            ignores: ['wifiCheck', 'error', 'start', 'enter', 'loading'],
            poster: posterUrl,
            hls: {
                fetchOptions: {
                    referrerPolicy: ''
                }
            }
        });
    };
    const listenPlayerEvent = () => {
        if (!player.current)
            return;
        player.current.on(Events.PLAY, () => { });
        player.current.on(Events.READY, () => {
            const playerWrapper = document === null || document === void 0 ? void 0 : document.getElementById("live-player");
            const video = playerWrapper === null || playerWrapper === void 0 ? void 0 : playerWrapper.querySelector('video');
            if (video) {
                video.style.objectFit = 'cover';
            }
            if (!isMiniProgramOrWebview()) {
                play();
            }
        });
        player.current.on(Events.ERROR, (err) => {
            player.current.destroy();
            player.current = null;
            onVideoError && onVideoError();
            handleVideoPlaying(PLAY_STATUS.LIVE_ERROR);
        });
        player.current.on(Events.ENDED, () => {
            player === null || player === void 0 ? void 0 : player.current.destroy();
            player.current = null;
            onVideoCompleted && onVideoCompleted();
        });
    };
    useEffect(() => {
        initPlayer();
        listenPlayerEvent();
        return () => {
            var _a, _b;
            (_b = (_a = player.current) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
            player.current = null;
        };
    }, []);
    const onVideoImageClick = () => {
        play();
    };
    return <>
      <View id="live-player" className="live-player">
      </View>
      <View x-if={isPlaying !== PLAY_STATUS.LIVE_DOING} style={{
        height: remUnit(liveWindowHeight),
        width: remUnit(liveWindowWidth),
        position: 'absolute'
    }} onClick={onVideoImageClick}>
        <Image source={{
        uri: posterUrl
    }} widthAuto heightAuto/>
      </View>
    </>;
});
export default memo(Video);
